// extracted by mini-css-extract-plugin
export var error = "Login-module--error--nzxd5";
export var welcomeContent = "Login-module--welcomeContent--ZE9nc";